// STEP 1 - Include Dependencies
// Include react
import React, { useEffect, useState } from "react";

// Include the react-fusioncharts component
import ReactFC from "react-fusioncharts";

// Include the fusioncharts library
import FusionCharts from "fusioncharts";

// Include the chart type
import Column2D from "fusioncharts/fusioncharts.charts";

// Include the theme as fusion
import FusionTheme from "fusioncharts/themes/fusioncharts.theme.fusion";
import { connect } from "react-redux";
// Adding the chart and theme as dependency to the core fusioncharts
ReactFC.fcRoot(FusionCharts, Column2D, FusionTheme);

function LineGraph(props) {
  const [performanceChartName, setPerformanceChartName] = React.useState(
    "TotalPerformanceData"
  );

  const [actualData, setActualData] = React.useState([]);
  const [allData, setAllData] = useState([]);

  const AllTypeOfCategory =
    props?.performanceGraphData && Object.keys(props.performanceGraphData);

  // console.log("in linegraph", props.performanceGraphData);
  //console.log("in linegraph actual data", actualData);

  const chartData = [];
  let dataCategory = [];
  props?.performanceGraphData?.["TotalPerformanceData"] &&
    Object.keys(props.performanceGraphData["TotalPerformanceData"]).map(
      (key) => {
        let tempObj = {
          label: key,
        };
        dataCategory.push(tempObj);
      }
    );

  useEffect(() => {
    // setPerformanceChartName(props.fundType);
    setActualData(
      allData.filter((eachData, index) => {
        if (eachData.seriesname === props.fundType) return eachData.data;
      })
    );
  }, [props.fundType, allData]);

  useEffect(() => {
    let dataTotal = [];
    let genericCategory = [];
    if (props?.performanceGraphData) {
      for (let index = 0; index < AllTypeOfCategory.length; index++) {
        let specificData = [];
        props?.performanceGraphData[`${AllTypeOfCategory[index]}`] &&
          Object.values(
            props?.performanceGraphData[`${AllTypeOfCategory[index]}`]
          ).map((key) => {
            let tempObj = {
              value: key,
            };
            specificData.push(tempObj);
          });
        let eachSeries = {
          seriesname: AllTypeOfCategory[index],
          data: specificData,
        };
        genericCategory.push(eachSeries);
      }

      // Fetch data to show on initial render
      props?.performanceGraphData?.["TotalPerformanceData"] &&
        Object.values(props.performanceGraphData["TotalPerformanceData"]).map(
          (key) => {
            let tempObj = {
              value: key,
            };
            dataTotal.push(tempObj);
          }
        );

      // Push data to allData usestate for intial render
      let forTotalData = {
        seriesname: "Total",
        data: dataTotal,
      };

      genericCategory.push(forTotalData);
      setAllData(genericCategory);
    }
  }, [props?.performanceGraphData]);

  const chartConfigs = {
    type: "msspline", // The chart type
    width: "100%", // Width of the chart
    height: "200", // Height of the chart
    dataFormat: "json", // Data type
    dataSource: {
      chart: {
        theme: "fusion",
        showXAxisLine: "1",
        xAxisLineColor: "#999999",
        showLegend: "0",
        // paletteColors: "#F3DFAA,#AD9042,#E6C774,#CCB265",
        lineThickness: "3",
        labelDisplay: "ROTATE",
      },
      categories: [
        {
          category: dataCategory,
        },
      ],
      dataset: actualData.length > 0 ? actualData : null,
    },
  };

  return <ReactFC {...chartConfigs} />;
}

const mapStatetoProps = (state) => {
  return {
    fundType: state.mainReducer.fundType,
  };
};

export default connect(mapStatetoProps)(LineGraph);
